export default {"src":"/pro/_next/static/media/usdjpy.2c30f204.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};